module.exports = "\n::ng-deep snack-bar-container{\n  height: 150px;\n  background: rgba(0,0,0,.5)!important;\n\n}\n\n::ng-deep .mat-simple-snackbar {\n  font-size: 1.5em !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  text-align: center !important;\n  line-height: 1.5em !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main